export default __webpack_public_path__ + "assets/400c92.png";